import axios from "axios";
import { APP_PATH } from "../api/backendPath";

/**
 * Therapist genders this physio center may register, as assigned by the admin
 * ("Gender Preference" on the physiotherapist user → physio_centers.allows_male_staff /
 * allows_female_staff, returned by GET /physiotherapist/profile).
 *
 * A missing flag counts as permitted, matching the backend column default, so centers
 * created before the setting existed stay unrestricted. If the profile can't be loaded
 * both genders are offered; the backend still rejects a gender that isn't permitted.
 * @returns {Promise<string[]>} Subset of ["Male", "Female"], never empty
 */
export const getPermittedTherapistGenders = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}${APP_PATH.physioProfile}`,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("usr_1a2b3c")}`,
        },
      },
    );
    const center = response.data?.data || {};
    const genders = [];
    if (center.allows_male_staff !== false) genders.push("Male");
    if (center.allows_female_staff !== false) genders.push("Female");
    return genders.length ? genders : ["Male", "Female"];
  } catch (error) {
    console.error("Error fetching permitted therapist genders:", error);
    return ["Male", "Female"];
  }
};
